import { render } from "./EmptyRouterView.vue?vue&type=template&id=01877af0"
import script from "./EmptyRouterView.vue?vue&type=script&lang=js"
export * from "./EmptyRouterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__